<template>
  <section class="local-lm-left-menu">
    <div class="level local-lm-logo">
      <div class="level-item has-text-centered">
        <figure class="image is-64x64">
          <router-link
            :to="{ name: 'Orders' }"
          >
          <img
            :src="loadLogo"
          />
          </router-link>
        </figure>
      </div>
    </div>
    <dashboard-menu />
  </section>
</template>

<script>
import LogoWhite from '@/assets/img/Movimenta_Supplier_W.svg'
import DashboardMenu from '@/components/dashboard/DashboardMenu'

export default {
  name: 'LeftMenu',
  components: {
    DashboardMenu
  },
  computed: {
    loadLogo () {
      return LogoWhite
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/LeftMenu.vue